import Hero from "@/components/Hero";
import MenuTiles from "@/components/MenuTiles";
import Contact from "@/components/Contact";

function HomePage() {
  return (
    <>
      <Hero />
      <MenuTiles />
      <Contact />
    </>
  );
}

export default HomePage;
